export default __webpack_public_path__ + "static/media/campaign-creators-gMsnXqILjp4-unsplash.d3b4e75a.jpg";